// extracted by mini-css-extract-plugin
export default {"inlineExternalLink":"inline-external-link_inlineExternalLink__Nu+QQ","canvas":"inline-external-link_canvas__xQ4eN","card":"inline-external-link_card__nv0hc"};